<template>
  <div id="gallery" class="section">
    <v-container>
      <h1>Gallery {{ type }}</h1>
         <galleryBlock :directory="type" :number="number" />
    </v-container>
  </div>
</template>

<script>
  import galleryBlock from '@/components/GalleryBlock'
  export default {  
    name: 'Gallery',
    components: { galleryBlock },
      data: ()=>({
        type:'',
        number: null
      }),
      created(){
        this.type = this.$route.params.type
        this.getArtWork(this.$route.params.type)
      },
      methods: {
        getArtWork(type){
          switch(type) {
            case 'cityscapes':
                this.type = 'cityscapes'
                this.number = 9            
              break
            case'dancers':
                this.type = 'dancers'
                this.number = 12
              break
            case'figures':
                this.type = 'figures'
                this.number = 3
              break
            case'interiors':
                this.type = 'interiors'
                this.number = 1
              break
            case'landscapes':
                this.type = 'landscapes'
                this.number = 22
              break  
            case'musicians':
                this.type = 'musicians'
                this.number = 0
              break  
            case'portraits':
                this.type = 'portraits'
                this.number = 28
              break    
            case'life':
                this.type = 'still-life'
                this.number = 12
              break                                                       
          }
        }
      }
  }
</script>


<style>
 #gallery .img-thumbnail {
    padding: 5px;
    border: 1px solid #ccc;
    float: left;
    border-radius: 5px;
 }
</style> 
